import { render, staticRenderFns } from "./TextError.vue?vue&type=template&id=633b8c9f&"
import script from "./TextError.vue?vue&type=script&lang=js&"
export * from "./TextError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports